__turbopack_context__.v({
  "icon-list": "icon-list-component-module-scss-module__b2NOBq__icon-list",
  "icon-list__brochure": "icon-list-component-module-scss-module__b2NOBq__icon-list__brochure",
  "icon-list__cart": "icon-list-component-module-scss-module__b2NOBq__icon-list__cart",
  "icon-list__cart-icon": "icon-list-component-module-scss-module__b2NOBq__icon-list__cart-icon",
  "icon-list__cart-icon--with-products": "icon-list-component-module-scss-module__b2NOBq__icon-list__cart-icon--with-products",
  "icon-list__icon": "icon-list-component-module-scss-module__b2NOBq__icon-list__icon",
  "icon-list__icon-wrapper": "icon-list-component-module-scss-module__b2NOBq__icon-list__icon-wrapper",
  "icon-list__info-bubble": "icon-list-component-module-scss-module__b2NOBq__icon-list__info-bubble",
  "icon-list__item": "icon-list-component-module-scss-module__b2NOBq__icon-list__item",
  "icon-list__item-metadata": "icon-list-component-module-scss-module__b2NOBq__icon-list__item-metadata",
  "icon-list__text": "icon-list-component-module-scss-module__b2NOBq__icon-list__text",
});
